import { render, staticRenderFns } from "./RechargeModal.vue?vue&type=template&id=2548a3ee&scoped=true"
import script from "./RechargeModal.vue?vue&type=script&lang=js"
export * from "./RechargeModal.vue?vue&type=script&lang=js"
import style0 from "./RechargeModal.vue?vue&type=style&index=0&id=2548a3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548a3ee",
  null
  
)

export default component.exports